import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "colse",
  "use": "colse-usage",
  "viewBox": "0 0 30 32",
  "content": "<symbol viewBox=\"0 0 30 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"colse\"><g fill-rule=\"nonzero\" stroke=\"#181818\" stroke-width=\"1.5\" fill=\"none\"><path d=\"M20.732 9.983L8.807 22.355M9.307 9.983l11.925 12.372\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol